<template>
  <component
    :is="componentType"
    :href="content.url"
    class="content-card__content"
  >
    <!-- Content card image -->
    <slot />

    <div
      v-if="hasText"
      class="content-card__copy"
      :style="{
        '--desktop-color': content.text_color,
        '--mobile-color': content.mobile_text_color,
      }"
      :class="{
        'gradient--desktop': content.use_gradient,
        'gradient--mobile': content.mobile_use_gradient,
        'text-center mb-m mb-xs-desktop': content.text_alignment === 'center'
      }"
    >
      <span
        v-if="hat"
        class="content-card__hat text-other-label-thin"
        v-text="hat"
      />

      <h2
        v-if="title"
        class="content-card__title text-body-l-medium mt-xs"
        v-html="title"
      />

      <div
        v-if="body"
        class="content-card__subtitle text-body-s-regular mt-s"
        v-html="body"
      />

      <div
        v-if="hasCta"
        class="mt-m"
      >
        <btn
          :label="content.button"
          class="content-card__button"
          modifiers="text"
          custom-element="span"
        />
      </div>
    </div>
  </component>
</template>

<script>

/**
 * Vue: Content card text
 * -----------------------------------------------------------------------------
 * Content card text used for the main collection's content cards
 *
 * @param {Object} content - Text settings from content card block
 *
 */

import Btn from '~global/btn/btn'
import { mapState } from 'vuex'

export default {
  name: 'ContentCardText',

  components: { Btn },

  props: {
    content: {
      type: Object,
      default: () => ({
        title: '',
        body: '',
        button: '',
        url: '',
      }),
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Compute body text
     * @returns {String}
     */
    body() {
      const { body, mobile_body } = this.content
      // eslint-disable-next-line camelcase
      return this.isMobile ? mobile_body : body
    },

    /**
     * Compute component type
     * @returns {string}
     */
    componentType() {
      return this.content.url ? 'a' : 'div'
    },

    /**
     * Compute title text
     * @returns {String}
     */
    title() {
      const { title, mobile_title } = this.content
      // eslint-disable-next-line camelcase
      return this.isMobile ? mobile_title : title
    },

    /**
     * Compute hat text
     * @returns {String}
     */
    hat() {
      const { hat, mobile_hat } = this.content
      // eslint-disable-next-line camelcase
      return this.isMobile ? mobile_hat : hat
    },

    /**
     * Compute if cta exists
     * @returns {Boolean}
     */
    hasCta() {
      return Boolean(this.content.button) && Boolean(this.content.url)
    },

    /**
     * Compute if text exists
     * @returns {Boolean}
     */
    hasText() {
      return (Boolean(this.title) || Boolean(this.body) || this.hasCta || Boolean(this.hat)) && !this.content.enable_stl
    },
  },
}
</script>
